import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "react-multi-carousel/lib/styles.css";
import Button from "../../shared/Button/Button";
import { useGlobalData } from "../../context/globalDataContxt";
import "../../helpers/font-awesome";
import "./NoteCard.scss";

function NoteCard({ note }) {

  const { configPucc } = useGlobalData();

  return (
    <div className="mb-4" key={`noveltiesNodesId-${note.id}`}>
      <div
        className={`news-card h-100 d-flex rounded shadow overflow-hidden position-relative flex-column`}
      >
        <div
          className={`news-image`}
          style={
            note.thumbnail?.url
              ? {
                  backgroundImage: `url(${note.thumbnail.url})`,
                }
              : {
                  backgroundImage: `url(${configPucc.noveltiesFeedConfig.noveltyImgDefaul?.url})`,
                }
          }
          role="img"
          alt={note.thumbnail?.alternativeText || ""}
        ></div>

        <div className="news-info flex-grow-1 p-4 d-flex flex-column">
          <div className="news-date">
            <small>{moment(note.date).locale("es").format("DD-MM-YYYY")}</small>
          </div>

          <h5 className="news-title">{note.noteName || note.title}</h5>

          <div className="noticies-markdown">
            <p>{note?.summary ? note.summary : null}</p>
          </div>

          <Button
            classButton={`text-left px-4 mb-0 rounded-0`}
            button={{
              url: `ucc.edu.ar/notas/${note.slug}`,
              label: "LEER NOTA",
            }}
            customButton={{ 
              variant: 'secondary_outline', 
              size: "", 
              shape: 'pill' 
            }}
            classContainer="d-flex mt-auto"
          />
        </div>
      </div>
    </div>
  );
}

export default NoteCard;

NoteCard.propTypes = {
  noveltie: PropTypes.object.isRequired,
};
